export const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  
  export const getBase64FromDataURL = (dataURL) => {
    return dataURL.split(",")[1];
  };
  
  export const initialFormState = {
    // employee_code: "",
    // hub: "",
    bill: "",
    date: "",
    amount: "",
    image: null,
  };